import { takeLatest, call, all, select } from "redux-saga/effects";

import {
  appliedFiltersSelector,
  fetchedDynamicFiltersSelector
} from "selectors/filtersSelector.js";

import { groupByProductsActions } from "actions/groupByProductsActions.js";
import { groupByBannerActions } from "actions/groupByBannerActions.js";
import { postData } from "sagas/postDataSaga.js";
import { getData } from "sagas/getDataSaga.js";

export const requestGroupByProducts = function*(action) {
  let { releaseId, selectedGroupByFilter, ...params } = action.payload;
  let requests = [];
  let applicableFilters = [];

  const appliedFilters = yield select(appliedFiltersSelector);
  const fetchedDynamicFilters = yield select(fetchedDynamicFiltersSelector);

  const pushUnique = filterOption => {
    const isExistingFilterOption = applicableFilters.find(option => {
      return option.get("name") === filterOption.get("name");
    });

    isExistingFilterOption === undefined && applicableFilters.push(filterOption);
  };

  // Mirrors RangeContainer: an applied selection narrows which groups are fetched.
  if (
    appliedFilters.getIn(["dynamic_filters", selectedGroupByFilter]) &&
    appliedFilters.getIn(["dynamic_filters", selectedGroupByFilter]).size > 0
  ) {
    // Dedupe by name: the API emits one entry per division/collection pair, so
    // the same group name can appear many times and would otherwise be fetched
    // (and rendered) once per occurrence.
    appliedFilters
      .getIn(["dynamic_filters", selectedGroupByFilter])
      .forEach(pushUnique);
  } else {
    const availableFilters = fetchedDynamicFilters.get(selectedGroupByFilter);

    // The selected grouping may be missing entirely when the catalog query
    // returns no rows; nothing to fetch in that case.
    if (!availableFilters) return;

    availableFilters.forEach(pushUnique);
  }

  applicableFilters.map(filter => {
    let payload = {
      ...params,
      filters: appliedFilters,
      category: selectedGroupByFilter,
      subcategory: filter
    };

    // Called rather than put as POST_DATA/GET_DATA: those run under takeEvery and
    // outlive this saga, so takeLatest could not cancel them. The catalog effect
    // re-requests several times on first load (filters, buyplan and warehouse
    // settle one after another), and each stale batch's responses landed after
    // the reset and were concatenated onto the next batch's - showing every
    // product two or three times. As calls, a newer request cancels this saga
    // and sharedApiSaga aborts the in-flight fetches before they dispatch.
    requests.push(
      call(postData, {
        path: `/api/releases/${releaseId}/products.json`,
        actions: groupByProductsActions,
        params: payload
      }),
      call(getData, {
        path: `/api/releases/${releaseId}/banner_asset`,
        actions: groupByBannerActions,
        params: { type: selectedGroupByFilter, value: filter.toJS() }
      })
    );
    return null;
  });

  yield all(requests);
};

export const watchRequestGroupByProducts = function*() {
  yield takeLatest(groupByProductsActions.request, requestGroupByProducts);
};
